import { render, staticRenderFns } from "./Scrap24.vue?vue&type=template&id=3c42b94c&scoped=true&"
import script from "./Scrap24.vue?vue&type=script&lang=js&"
export * from "./Scrap24.vue?vue&type=script&lang=js&"
import style0 from "./Scrap24.vue?vue&type=style&index=0&id=3c42b94c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c42b94c",
  null
  
)

export default component.exports